<div class="industry-analysis-page">
  <div class="content">
    <div class="top-action-section">
      <div class="filter-container">
        <div class="filter">
          <app-lineitem-filter
            [options]="lineItemsData"
            [selectedValue]="
              !isLineUpdateInProgress && lineItem
                ? { value: lineItem.uniquesliid, label: lineItem.name }
                : {}
            "
            [selectedOptionsId]="lineItem ? [lineItem.uniquesliid] : undefined"
            liFilterId="industryKpiLI"
            [bottomBorderView]="true"
            [disabled]="
              isMetaInProgress ||
              totalLogicCheckInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            placeholder="&nbsp;Add Line Item"
            label="Line Items"
            [showButton]="false"
            [showLabel]="true"
            (onValueChange)="handleLineItemSelection($event)"
          ></app-lineitem-filter>
          <!-- <app-lineitem-with-searchbox-in-dropdown
            [stdLines]="lineItemsData"
            [selectedLineItem]="lineItem"
            [suggestedLines]="suggestedLineItems"
            [disabled]="
              isMetaInProgress ||
              totalLogicCheckInProgress ||
              isStdLineItemsUpdateInProgress ||
              isUserSettingUpdateInProgress
            "
            lineItemInputId="industryCoreLineItemInput"
            (onLineItemSelection)="handleLineItemSelection($event)"
          >
          </app-lineitem-with-searchbox-in-dropdown> -->
        </div>
        <div class="filter">
          <app-growth-revision-filter
            (saveDataview)="updateGrowthRevision($event)"
            [dataview]="dataview"
            [isIndustryPage]="true"
            [disable]="
              isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
            "
          ></app-growth-revision-filter>
        </div>
        <div class="filter industry-currency-filter">
          <va-currency-select
            size="small"
            selectWidth="78"
            labelPlacement="top"
            [bottomBorderView]="true"
            [suggestedCurrencies]="currencyOptionList"
            [selectedCurrency]="currency"
            [disabled]="
              isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
            "
            [apiEP]="apiEP"
            apiUrl="/api/get_available_currencies"
            (onChange)="handleCurrencyChange($event)"
          >
          </va-currency-select>
        </div>
        <div class="filter">
          <va-period-filter
            [periodData]="periodData"
            [filterWidthVariation]="2"
            [disabled]="
              isMetaInProgress || isUserSettingUpdateInProgress || !lineItem
            "
            [dataAvailable]="periodsWithAvailableData"
            (onApply)="handlePeriodApply($event)"
          ></va-period-filter>
        </div>
        <div>
          <app-toggle-checkbox
            [disabled]="
              isMetaInProgress ||
              isCompsDataInProgress ||
              isUserSettingUpdateInProgress ||
              !lineItem
            "
            [checkboxValue]="showBlankRows"
            [label]="showBlankRowsLabel"
            labelInfo="Consensus values do not exist for all companies in all time periods."
            (onCheckboxChange)="handleShowBlanksSwitchChange($event)"
          ></app-toggle-checkbox>
        </div>
      </div>
      <div class="cta-right-section">
        <!-- export button -->
        <button
          class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
          [ngClass]="[
            isCompExportPopoverVisible ? 'va-button--active' : '',
            isCompsDataInProgress ||
            isMetaInProgress ||
            !lineItem ||
            !tickers ||
            !tickers.length ||
            !compsTableData ||
            !compsTableData.rows ||
            !compsTableData.rows.length
              ? 'va-button--disabled'
              : ''
          ]"
          nz-popover
          nzPopoverTrigger="click"
          [nzPopoverContent]="exportOptionsTemplate"
          nzPopoverPlacement="bottomRight"
          [(nzPopoverVisible)]="isCompExportPopoverVisible"
          title="Export Table"
        >
          <va-icon
            isFontAwesome="true"
            *ngIf="!isCompTableExportInProgress; else exportLoading"
            [name]="fasFileExcel"
            class="va-button-icon"
          ></va-icon>
        </button>

        <!-- edit table -->
        <button
          class="va-button va-icon-button va-button-outline va-button-outline--primary"
          [ngClass]="[
            isCompsDataInProgress ||
            isMetaInProgress ||
            !tickers ||
            !tickers.length ||
            (compsTableData && compsTableData.rows.length > 50) ||
            !lineItem ||
            !compsTableData ||
            !compsTableData.rows ||
            !compsTableData.rows.length
              ? 'va-button--disabled'
              : ''
          ]"
          [title]="
            compsTableData && compsTableData.rows.length > 50
              ? 'Company count should be up to 50'
              : 'Edit Table'
          "
          (click)="handleEditTableClick()"
        >
          <va-icon
            isFontAwesome="true"
            [name]="fasTable"
            class="va-button-icon"
          ></va-icon>
        </button>
      </div>
    </div>
    <div class="industry-comps-container">
      <app-comps-grid
        [metaReady]="!isMetaInProgress"
        [dataReady]="!isCompsDataInProgress && !totalLogicCheckInProgress"
        [isTimeSeries]="true"
        [fuzzySwitch]="false"
        [compsTableData]="compsTableData"
        [hasUnsavedData]="false"
        [hasContextMenu]="false"
        [hasFormulaBar]="true"
        [maxHeight]="
          isTableInExpandState
            ? showMLActiveStateHeight
            : showMLTableInitialHeight
        "
        [tableClassName]="'industry-comp-table-container ' + compTableClassName"
        [isIndustryPage]="true"
        [allowTickerDeletion]="false"
        [showCompanyCount]="true"
        [showBlankTickers]="showBlankRows"
        [sortByColumnId]="activePeriod"
      >
      </app-comps-grid>
      <div class="show-ml-container" *ngIf="!isMetaInProgress">
        <div
          *ngIf="hasShowMoreButton && !isCompsDataInProgress"
          (click)="handleShowMLClick()"
          class="show-ml-cta"
          [ngClass]="{ 'show-ml-cta--active': isTableInExpandState }"
          [ngStyle]="{
            'background-image': isTableInExpandState
              ? 'url(' + assets + '/show-ml-active.png)'
              : 'url(' + assets + '/show-ml-default.png)'
          }"
        >
          {{ isTableInExpandState ? "Show Less" : "Show More" }}
          <va-icon
            size="small"
            [name]="isTableInExpandState ? 'chevron-up' : 'chevron-down'"
            class="show-ml-angle-icon"
          ></va-icon>
        </div>
        <div class="comp-table-extra-footnote" *ngIf="!isCompsDataInProgress">
          {{ magnitudeMessage }}
        </div>
      </div>
    </div>
    <div class="industry-charts-container">
      <div class="industry-chart-action">
        <div>
          <div class="header">
            {{
              viewBy.includes("revision") ? "Revisions Chart" : "Trends Chart"
            }}
            {{ lineItem && lineItem.name ? " | " + lineItem.name : "" }}
          </div>
          <div class="industry-chart-filters">
            <nz-radio-group
              [(ngModel)]="radioValue"
              (ngModelChange)="onChangeChartView()"
              [ngStyle]="{
                'pointer-events': chartInstance === null ? 'none' : 'auto'
              }"
            >
              <label nz-radio nzValue="top10"> Top 10 </label>
              <label nz-radio nzValue="top5"> Top 5 </label>
              <label nz-radio nzValue="total" [nzDisabled]="!lineHasTotal">
                Total
              </label>
              <label nz-radio nzValue="average"> Average </label>
            </nz-radio-group>
            <div class="chart-filter-vertical-divider"></div>
            <label
              nz-checkbox
              class="mr-8"
              [(ngModel)]="isIndexToHundreadSelected"
              (ngModelChange)="handleIndexCheckobChange($event)"
              [nzDisabled]="
                isMetaInProgress ||
                isUserSettingUpdateInProgress ||
                !lineItem ||
                isCompsDataInProgress ||
                !chartInstance
              "
              >Index Chart to 100</label
            >
            <div
              *ngIf="selectedChart !== 'industry-page-timeseries'"
              class="chart-filter-vertical-divider"
            ></div>
            <div
              class="estimate-filter"
              *ngIf="selectedChart !== 'industry-page-timeseries'"
              [ngClass]="{
                'estimates-filter--active': yearTypeFilterVisible
              }"
            >
              <label class="filter-label estimates-filter-label"
                >Estimates</label
              >
              <button
                nz-button
                nz-popover
                nzPopoverTrigger="click"
                [nzPopoverContent]="estimatesTemplate"
                nzPopoverPlacement="bottomLeft"
                (nzPopoverVisible)="yearTypePopoverChange()"
                [(nzPopoverVisible)]="yearTypeFilterVisible"
                class="estimate-btn"
                style="width: auto"
                [disabled]="
                  isMetaInProgress ||
                  !chartInstance ||
                  !radioValueEstimates ||
                  !lineItem
                "
                nzPopoverOverlayClassName="industry-estimates-dropdown-popover"
                nzPopoverBackdrop="true"
              >
                <!-- <span *ngIf="!lblVal">Date Published</span> -->
                <span>{{ radioValueEstimates }}</span>
                <span></span>
                <i
                  nz-icon
                  [nzType]="yearTypePopoverOpen ? 'up' : 'down'"
                  class="arrow"
                ></i>
              </button>
              <ng-template #estimatesTemplate>
                <nz-radio-group
                  [(ngModel)]="radioValueEstimates"
                  nzName="radiogroupEstimate"
                  *ngFor="let period of periodList"
                  class="estimates-group"
                  (ngModelChange)="onEstimateChange()"
                >
                  <label nz-radio [nzValue]="period">{{ period }}</label>
                </nz-radio-group>
              </ng-template>
            </div>
          </div>
        </div>
        <div class="cta-right-section">
          <div
            nz-popover
            nzPopoverTrigger="click"
            [nzPopoverContent]="downloadOptionsTemplate"
            [(nzPopoverVisible)]="downloadOptVisible"
            class="va-button va-icon-button va-button-outline va-button-outline--primary mr-12"
            [ngClass]="[
              downloadOptVisible ? 'va-button--active' : '',
              isCompsDataInProgress ||
              isMetaInProgress ||
              !lineItem ||
              !tickers ||
              !tickers.length ||
              !chartFilters ||
              !chartFilters.tickerIds ||
              !chartFilters.tickerIds.length
                ? 'va-button--disabled'
                : ''
            ]"
            nzPopoverPlacement="bottom"
            title="Download Chart"
          >
            <va-icon
              isFontAwesome="true"
              [name]="fasArrowToBottom"
              class="va-button-icon"
            ></va-icon>
          </div>
          <ng-template #downloadOptionsTemplate>
            <div class="download-opt" (click)="downloadValue(4)">
              Print Chart
            </div>
            <hr class="solid" />
            <div (click)="downloadValue(0)" class="download-opt">
              Download PNG
            </div>
            <div (click)="downloadValue(1)" class="download-opt">
              Download JPEG
            </div>
            <div (click)="downloadValue(2)" class="download-opt">
              Download PDF
            </div>
            <div (click)="downloadValue(3)" class="download-opt">
              Download SVG
            </div>
            <!-- <hr class="solid" />
              <div (click)="onExport()" class="download-opt">
                Export Value
              </div> -->
          </ng-template>
          <button
            class="va-button va-icon-button va-button-outline va-button-outline--primary"
            [ngClass]="[
              !(
                chartFilters &&
                chartFilters.tickers &&
                chartFilters.tickers.length
              ) ||
              radioValue === 'total' ||
              radioValue === 'average' ||
              isCompsDataInProgress ||
              isMetaInProgress ||
              !lineItem ||
              !tickers ||
              !tickers.length
                ? 'va-button--disabled'
                : ''
            ]"
            title="Edit Chart"
            (click)="handleEditChartClick()"
          >
            <va-icon
              isFontAwesome="true"
              [name]="fasChartLine"
              class="va-button-icon"
            ></va-icon>
          </button>
        </div>
      </div>
      <app-industry-page-chart-section
        [chartType]="selectedChart"
        [chartFilters]="chartFilters"
        [industry]="industry"
        [compsTableData]="compsTableData"
        [compsDataReady]="!isCompsDataInProgress && !totalLogicCheckInProgress"
        [compsMetaReady]="!isMetaInProgress"
        [lineHasTotal]="lineHasTotal"
        [tabName]="pageShortName"
        [estimatePeriodOptions]="periodList"
        (onEstimatePeriodChange)="onEstimateChange()"
        (onChartInstanceChange)="onChartInstance($event)"
      >
      </app-industry-page-chart-section>
    </div>
  </div>
</div>
<ng-template #exportOptionsTemplate>
  <div (click)="exportValue(1)" class="comp-export-opt">Values</div>
  <div (click)="exportValue(0)" class="comp-export-opt">
    Excel Add-In Formulas
  </div>
</ng-template>
<ng-template #exportLoading>
  <div>
    <ng-template #indicatorTemplate>
      <va-icon
        isFontAwesome="true"
        [name]="faSpinner"
        spin="true"
        class="va-button-icon"
      ></va-icon>
    </ng-template>
    <nz-spin nzSimple [nzIndicator]="indicatorTemplate"> </nz-spin>
  </div>
</ng-template>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faCheck"
      class="snack-icon snack-success-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faTimesCircle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faInfoCircle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>

<app-no-ticker-popup
  [showNoTickerPopup]="isNoTickerPopupVisible"
  (onNoTickerPopupChangeClick)="onNoTickerPopupChangeClick()"
></app-no-ticker-popup>
